import React, { useEffect } from 'react';
import LoginComponent from '../components/auth/Login';
import loginImage from '../assets/images/login-image.jpg';
import './Login.css';

const Login = () => {

    useEffect(() => {
      document.title += ' - Login';
      // This will clean up the title when component unmounts
      return () => {
        document.title = 'CVance'; // Default title
      };
    }, []);

  return (
    <div className="auth-page">
      <div className="container">
        <div className="auth-container">
          <div className="auth-content">
            <LoginComponent />
          </div>
          <div className="login-image">
            <img src={loginImage} className='image'>
            </img>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;